<template>
	<div class="compCrumbs">
		<div class="compCrumbsItem" @click="toBack">
			<img src="../assets/img/back.png" class="backImg"/>
			<span >返回</span>
		</div>
		<div class="compCrumbsItem" @click="toIndex">
			<img src="../assets/img/backback.png" class="backImg"/>
			<span >返回商城首页</span>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				
			}
		},
		
		mounted() {
			// let route = this.$router.getCurrentPages();
			// console.log(route)
		},
		methods: {
			toBack(){
				if(this.$route.query.type==='payResult'){
					this.$router.push({path:"/"})
				}else{
					this.$router.back()
				}
			},
			toIndex(){
				this.$router.push({path:"/"})
			},
		},
	}
</script>
<style lang="scss" scoped>
	.compCrumbs{
		display: flex;justify-content: space-between;font-size: 18px;color:#5f5f72;padding:20px 0 20px;width:100%;
		.compCrumbsItem{
			cursor: pointer;
			.backImg{
				width:24px;height: 24px;padding-right: 4px;vertical-align: sub;
			}
		}
		
	}
</style>
